import React from 'react'
import { Box, Typography, Chip, Paper, Stack } from '@mui/material'
import { Circle as CircleIcon } from '@mui/icons-material'

const AlertNotifsList = ({ notifications }) => {
  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 2 }}>
      {notifications && notifications.length > 0 ? (
        <Stack spacing={1.5}>
          {notifications.map((notification) => (
            <Paper
              key={notification.id}
              elevation={0}
              sx={{
                p: 2.5,
                borderRadius: 2,
                border: '1px solid',
                borderColor: notification.lu ? 'grey.200' : 'primary.light',
                backgroundColor: notification.lu ? 'grey.50' : 'primary.50',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
                position: 'relative',
                '&:hover': {
                  borderColor: 'primary.main',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                }
              }}
            >
              {!notification.lu && (
                <CircleIcon 
                  sx={{ 
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    fontSize: 10,
                    color: 'primary.main'
                  }} 
                />
              )}
              
              <Stack spacing={1}>
                <Typography 
                  variant="subtitle1" 
                  sx={{ 
                    fontWeight: 600,
                    pr: 3,
                    color: notification.lu ? 'text.secondary' : 'text.primary'
                  }}
                >
                  {notification.titre}
                </Typography>
                
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: 'text.secondary',
                    lineHeight: 1.6
                  }}
                >
                  {notification.contenu}
                </Typography>
                
                <Stack 
                  direction="row" 
                  spacing={1} 
                  alignItems="center"
                  flexWrap="wrap"
                  sx={{ mt: 0.5 }}
                >
                  {/* <Chip 
                    label={notification.chaine}
                    size="small"
                    sx={{ 
                      height: 24,
                      fontSize: '0.75rem',
                      backgroundColor: 'primary.50',
                      color: 'primary.main',
                      border: '1px solid',
                      borderColor: 'primary.200'
                    }}
                  />
                  
                  <Chip 
                    label={notification.pv}
                    size="small"
                    sx={{ 
                      height: 24,
                      fontSize: '0.75rem',
                      backgroundColor: 'grey.100',
                      color: 'text.secondary'
                    }}
                  /> */}
                  
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      color: 'text.disabled',
                      ml: 'auto !important'
                    }}
                  >
                    {new Date(notification.date).toLocaleString('fr-FR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </Typography>
                </Stack>
              </Stack>
            </Paper>
          ))}
        </Stack>
      ) : (
        <Box 
          sx={{ 
            textAlign: 'center', 
            py: 8,
            color: 'text.disabled'
          }}
        >
          <Typography variant="body1">
            Aucune notification disponible.
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default AlertNotifsList